import { Box, Card, Skeleton } from '@factorialco/deprecated-design-system'

export const AccountLoadingCard = () => (
  <Box height="s120">
    <Card height="s120">
      <Card.Content>
        <Box
          width="full"
          flexDirection="row"
          justifyContent="spaceBetween"
          paddingBottom="s16"
          gap="s12"
          alignItems="flexStart"
        >
          <Box
            flexDirection="column"
            justifyContent="flexStart"
            gap="s4"
            width="full"
            paddingTop="s4"
          >
            <Skeleton width="s140" height="s16" />
            <Skeleton width="s200" height="s16" />
          </Box>
          <Skeleton width="s64" height="s24" />
        </Box>
        <Skeleton width="s120" height="s32" />
      </Card.Content>
    </Card>
  </Box>
)
